import { Link } from "react-router-dom";

const NAV = [
  { to: "/about",   label: "हमारे बारे में" },
  { to: "/blog",    label: "ब्लॉग" },
  { to: "/news",    label: "समाचार" },
  { to: "/gallery", label: "गैलरी" },
  { to: "/donate",  label: "दान करें" },
  { to: "/contact", label: "संपर्क" },
];

const SERVICES = [
  "दैनिक आरती — प्रातः 6:00",
  "विशेष पूजा अनुष्ठान",
  "निःशुल्क भंडारा",
  "मिथिला मध्य परिक्रमा",
  "विवाह पंचमी उत्सव",
  "फूललोड़ी परंपरा",
];

const FESTIVALS = [
  { name: "मिथिला मध्य परिक्रमा", time: "फाल्गुन (15 दिन)" },
  { name: "विवाह पंचमी",         time: "अगहन" },
  { name: "राम नवमी",            time: "चैत्र" },
  { name: "जानकी नवमी",          time: "वैशाख" },
];

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden">
      {/* Top gradient border */}
      <div className="h-1" style={{ background: "linear-gradient(90deg, #8B1A1A, #E8621A, #F4A500, #E8621A, #8B1A1A)" }} />

      {/* Main footer body */}
      <div
        className="relative"
        style={{ background: "linear-gradient(180deg, #1A0800 0%, #2C1408 60%, #3D1C02 100%)" }}
      >
        {/* Decorative bg Om */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.03]">
          <span style={{ fontSize: "60vw", lineHeight: 1, color: "#F4A500" }}>🕉️</span>
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-5 py-10 sm:py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

            {/* Brand / Trust Info */}
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full flex items-center justify-center text-xl"
                  style={{ background: "linear-gradient(135deg, #8B1A1A, #E8621A, #F4A500)" }}>
                  🕉️
                </div>
                <div>
                  <p className="font-serif font-bold text-lg leading-none" style={{ color: "#F4A500" }}>
                    फुलहर धाम
                  </p>
                  <p className="text-[10px] tracking-widest uppercase" style={{ color: "rgba(254,246,228,0.5)" }}>
                    तीर्थ क्षेत्र ट्रस्ट
                  </p>
                </div>
              </div>

              <p className="text-sm leading-relaxed mb-4" style={{ color: "rgba(254,246,228,0.65)" }}>
                सीता राम प्रथम मिलन की पावन भूमि — गिरिजा पूजन की पावन स्थली, मिथिला, बिहार।
              </p>

              <div className="space-y-2">
                {[
                  { icon: "📍", text: "फुलहर धाम, हरलाखी, मधुबनी — 847240" },
                  { icon: "📞", text: "+91 9470820521", href: "tel:+919470820521" },
                  { icon: "✉️", text: "shreesitaramjimandir@gmail.com", href: "mailto:shreesitaramjimandir@gmail.com", small: true },
                  { icon: "🕒", text: "प्रातः 6:00 — संध्या 7:00" },
                ].map(({ icon, text, href, small }, i) => (
                  <div key={i} className="flex items-start gap-2.5 text-xs" style={{ color: "rgba(254,246,228,0.7)" }}>
                    <span className="flex-shrink-0 mt-0.5">{icon}</span>
                    {href
                      ? <a href={href} className={`hover:text-yellow-300 transition-colors font-medium ${small ? "break-all" : ""}`}>{text}</a>
                      : <span>{text}</span>}
                  </div>
                ))}
              </div>

              {/* Badges */}
              <div className="flex flex-wrap gap-2 mt-4">
                {["NGO: BR/2025/0853517", "Trust No: 746"].map((b) => (
                  <span key={b} className="text-[9px] font-bold px-2 py-1 rounded-full"
                    style={{ background: "rgba(244,165,0,0.12)", color: "#F4A500", border: "1px solid rgba(244,165,0,0.2)" }}>
                    {b}
                  </span>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-bold text-sm uppercase tracking-wider mb-5" style={{ color: "#F4A500" }}>
                त्वरित लिंक
              </h4>
              <ul className="space-y-2.5">
                {NAV.map(({ to, label }) => (
                  <li key={to}>
                    <Link to={to}
                      className="text-sm transition-colors hover:translate-x-1 inline-flex items-center gap-1.5"
                      style={{ color: "rgba(254,246,228,0.65)" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "#F4A500")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(254,246,228,0.65)")}>
                      <span className="text-[10px]" style={{ color: "rgba(244,165,0,0.4)" }}>›</span>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-bold text-sm uppercase tracking-wider mb-5" style={{ color: "#F4A500" }}>
                सेवाएं
              </h4>
              <ul className="space-y-2.5">
                {SERVICES.map((s) => (
                  <li key={s} className="text-sm flex items-start gap-1.5" style={{ color: "rgba(254,246,228,0.65)" }}>
                    <span className="text-xs mt-0.5" style={{ color: "rgba(244,165,0,0.5)" }}>🪷</span>
                    {s}
                  </li>
                ))}
              </ul>
            </div>

            {/* Festivals */}
            <div>
              <h4 className="font-bold text-sm uppercase tracking-wider mb-5" style={{ color: "#F4A500" }}>
                मुख्य उत्सव
              </h4>
              <div className="space-y-3">
                {FESTIVALS.map(({ name, time }) => (
                  <div key={name} className="p-3 rounded-xl"
                    style={{ background: "rgba(244,165,0,0.07)", border: "1px solid rgba(244,165,0,0.12)" }}>
                    <p className="text-sm font-semibold" style={{ color: "rgba(254,246,228,0.9)" }}>{name}</p>
                    <p className="text-xs mt-0.5" style={{ color: "rgba(254,246,228,0.45)" }}>{time}</p>
                  </div>
                ))}
              </div>

              {/* Dev status */}
              <div className="mt-4 p-3 rounded-xl"
                style={{ background: "rgba(30,91,71,0.2)", border: "1px solid rgba(30,91,71,0.3)" }}>
                <p className="text-xs font-bold" style={{ color: "#4ADE80" }}>🏗️ विकास कार्य प्रगति पर</p>
                <p className="text-[10px] mt-1" style={{ color: "rgba(254,246,228,0.5)" }}>
                  ₹31.13 करोड़ — बिहार सरकार
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t" style={{ borderColor: "rgba(244,165,0,0.1)" }}>
          <div className="max-w-5xl mx-auto px-4 sm:px-5 py-3">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-center">
              <p className="text-xs" style={{ color: "rgba(254,246,228,0.4)" }}>
                © {year} सीता राम प्रथम मिलन, पुष्प वाटिका मंदिर तीर्थ क्षेत्र ट्रस्ट (फुलहर धाम) · सर्वाधिकार सुरक्षित
              </p>
              <p className="text-xs font-serif italic" style={{ color: "rgba(244,165,0,0.5)" }}>
                "दानं धर्मस्य मूलम्" 🕉️
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
